<template>
  <span>
    <span v-for="(tag, index) in tags" :key="index">
      <span
        :style="tag.source == 'kronos' || tag.source == 'ukg' ? 'text-decoration: underline;' : ''"
      >
        <span>{{ tag.description || tag.name }}</span>
      </span>

      <span v-if="index != tags.length - 1">, </span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
    },
  },
};
</script>
